import React from "react";
import styled from "styled-components";

const Card = styled.article`
  display: flex;
  flex-direction: column;
  color: #fff;
  margin: 20px;
  width: 30%;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  /* Tablette */
  @media (max-width: 1024px) {
    width: 45%;
  }

  /* Mobile */
  @media (max-width: 768px) {
    width: 100%;
    margin: 10px 0;
  }
`;

const CardImage = styled.img`
  width: 100%;
  object-fit: cover;
  height: 220px;

  @media (max-width: 768px) {
    height: 180px;
  }
`;

const CardContent = styled.div`
  background-color: ${(props) => props.color};
  display: flex;
  flex-direction: column;
  padding: 20px;
  min-height: 280px;
  flex-grow: 1;

  @media (max-width: 768px) {
    padding: 16px;
    min-height: auto;
  }
`;

const CardTitle = styled.h2`
  font: 800 28px/124.5% Poppins, sans-serif;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const CardDescription = styled.ul`
  font: 500 16px/20px Poppins, sans-serif;
  padding-left: 20px;
  flex-grow: 1;

  @media (max-width: 768px) {
    font-size: 14px;
    padding-left: 16px;
  }
`;

const CardDescriptionItem = styled.li`
  margin-bottom: 8px;
`;

const Button = styled.button`
  font-family: Noto Sans JP, sans-serif;
  border-radius: 10px;
  background: #ff457d;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.25);
  color: white;
  font-weight: bold;
  border: none;
  padding: 12px 32px;
  cursor: pointer;
  width: fit-content;
  align-self: center;
  margin-top: 20px;
  transition: background 0.3s ease, transform 0.3s ease;

  &:hover {
    background: #ff6f91;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    padding: 12px;
  }
`;

const SubscriptionCard = ({ type, color, description, imageSrc, price }) => (
  <Card>
    <CardImage src={imageSrc} alt={`${type} subscription`} />
    <CardContent color={color}>
      <CardTitle>{type}</CardTitle>
      <CardTitle>{price}</CardTitle>
      <CardDescription>
        {description.map((item, index) => (
          <CardDescriptionItem key={index}>{item}</CardDescriptionItem>
        ))}
      </CardDescription>
      <Button
        onClick={() =>
          window.open("https://app.toyaloo.africa/setting/subscription", "_blank")
        }
      >
        Souscrire
      </Button>
    </CardContent>
  </Card>
);

export default SubscriptionCard;
